module.exports = __webpack_public_path__ + "static/platform-b7ca2b9496d163987787f20575c1be9d.png";